import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getProfessionnalInformationEtatiqueRequest: ['response'],
    getProfessionnalInformationEtatiqueSuccess: ['response', 'loading'],
    getProfessionnalInformationEtatiqueFailure: ['error'],
})

export const getProfessionnalInformationEtatiqueTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    error: null,
    loading: null,
})

/* ------------- Reducers ------------- */

const getProfessionnalInformationEtatiqueSuccess = (state, { response }) =>
    state.merge({
        error: false,
        response,
        loading: false,
    })
const getProfessionnalInformationEtatiqueFailure = (state, { error }) =>
    state.merge({
        loading: false,
        error,
    })
const getProfessionnalInformationEtatiqueRequest = state =>
    state.merge({ loading: true, error: null })

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_PROFESSIONNAL_INFORMATION_ETATIQUE_REQUEST]: getProfessionnalInformationEtatiqueRequest,
    [Types.GET_PROFESSIONNAL_INFORMATION_ETATIQUE_SUCCESS]: getProfessionnalInformationEtatiqueSuccess,
    [Types.GET_PROFESSIONNAL_INFORMATION_ETATIQUE_FAILURE]: getProfessionnalInformationEtatiqueFailure,
})
